<template>
    <div>
        <div class="rules__header" style="height: 56px;">
            <div class="text-bold rules__header-wrapper">
                <div class="rules__header-left">
                    <div class="text-size-l text-bold search-result">
                        Заскринкастить
                    </div>
                </div>
            </div>
        </div>
        <div class="content moderator-rules">
            <div class="container">
                <div class="container__full container-scroll container__right"
                     :class="{'container__removed-page': true}" style="padding-top: 16px !important;">

                    <rules-list v-if="closeSearch"
                                @openeditrule="isChangeRule = false" :filterType="filterType"
                                :isErrorPage="is404"></rules-list>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
import {mapState} from 'vuex';
import AsideSticky from '@/components/AsideSticky.vue';
import Gallery from '@/components/Gallery.vue';
import Popup from '@/components/modal/Popup.vue';
import AddRule from '@/components/modal/rules/AddRule.vue';
import RuleDetail from '@/components/modal/rules/RuleDetail.vue';
import Tumbler from '@/components/Tumbler.vue';
import RulesPopups from '@/components/RulesPopups.vue';
import RulesSections from '@/components/moderator/Rules/Sections.vue';
import RulesList from '@/components/moderator/Rules/List.vue';
import VueFooter from '@/components/VueFooter.vue';
import InputStyled from '@/components/forms/InputStyled.vue';
import TextareaField from '@/components/forms/TextareaField.vue';
import InputSelect from '@/components/forms/InputSelect.vue';
import SubmitBtn from '@/components/forms/SubmitBtn.vue'
import TextEditorNew from '@/components/editor/TextEditorNew.vue'
import draggable from '@/helpers/vuedraggable.js';
import {Hooper, Slide, Navigation as HooperNavigation} from 'hooper';
import {Editor, EditorContent, EditorMenuBar} from 'tiptap';
import InputSelectNew from '@/components/forms/InputSelectNew.vue';
import Tooltip from '@/components/Tooltip.vue';
import NotifyReset from '@/components/NotifyReset.vue';
import {
    Placeholder,
    History,
    Bold,
    OrderedList,
    BulletList,
    ListItem,
    Italic,
    Heading,
    HorizontalRule,
    Blockquote,
} from 'tiptap-extensions'
import {
    Text,
    Doc,
} from 'tiptap'
import {scrollTo} from '@/helpers/animate.js';
import {copyTextToClipboard} from "@/helpers/util/helper";

export default {
    metaInfo() {
        return {
            title: 'РЕГЛАМЕНТЫ И ПРАВИЛА',
            titleTemplate: this.$store.state.options.titleTemplate
        }
    },
    name: "Rules",
    components: {
        AsideSticky,
        Gallery,
        AddRule,
        RulesSections,
        RulesList,
        VueFooter,
        InputStyled,
        TextareaField,
        InputSelect,
        SubmitBtn,
        draggable,
        Hooper,
        Slide,
        HooperNavigation,
        TextEditorNew,
        EditorContent,
        EditorMenuBar,
        Popup,
        InputSelectNew,
        Tumbler,
        RuleDetail,
        Tooltip,
        NotifyReset,
        RulesPopups,
    },
    data: function () {
        return {
            ruleType: 0,
            focus: false,
            focused: false,
            search: '',
            isShowedViewer: false,
            inputText: '',
            currentSlide: 1,
            catError: false,
            repeatCatError: false,
            cursorPos: 0,
            tryScroll: 0,
            backToList: false,
            recoverItem: '',
            screenShotLink: {
                value: "",
                error: false,
                btnType: 'normal',
            },
            link: {
                value: "",
                error: false,
                btnType: 'normal',
            },
            save: {
                btnType: 'normal',
            },
            typesOptions: {
                0:{ name: 'все'},
                1: {name: 'заготовка'},
                2: {name: 'черновик'},
                4: {name: 'правило'},
            },
			typesSelectOptions: [
                {id: 0, name: 'все'},
                {id: 1, name: 'заготовка'},
                {id: 2, name: 'черновик'},
                {id: 4, name: 'правило'},
            ],
            filterType: {
                value: 0,
            },
            scrollID: false,
            isChangeRule: false,
            appPath: process.env.VUE_APP_PATH_BACK,
            isCurAfterPasteFile: false,
            scrollPositionAfterPasteFile: false,

        }
    },
    computed: {
        ...mapState({
            popups: state => state.popups.items,
            filterRuleType: state => state.rules.selectedFilterRuleType,
            sections: state => state.rules.sections,
            sectionsLock: state => state.rules.sectionsLock,
            rolled: state => state.rules.rolled,
            topSections: state => state.rules.topSections,
            isLoadItems: state => state.rules.isLoadItems,
            isLoadSections: state => state.rules.isLoadSections,
            isLoadEditRule: state => state.rules.isLoadEditRule,
            cursorPositionObj: state => state.rules.cursorPositionObj,
            useShortcut: state => state.rules.useShortcut,
            hasSelectedSection: state => state.rules.hasSelectedSection,
            canDragState: state => state.rules.canDrag,
            item: state => state.rules.editItem,
            items: state => state.rules.items,
            isSearch: state => state.rules.isSearch,
            isSearchPrev: state => state.rules.isSearchPrev,
            user: state => state.users.user,
            searchStr: state => state.rules.searchStr,
            first404: state => state.rules.first404,
            rule: state => state.rules.openedRule,
            scrollTop: state => state.rules.scrollTop,
            tumblers: state => state.rules.tumblers,
            previousSection: state => state.rules.previousSection,
            isEdit: state => state.rules.isEdit,
            closeSearch: state => state.rules.closeSearch,
        }),

        is404() {
            let is404 = false;

            if (this.isNotFoundRule()) {
                is404 = true;
            }

            let topSection = this.topSections.find(sect => sect.id === this.$route.params.id);
            let subSectionId = false;

            if (this.$route.params.id) {
                if (topSection) {
                    if (this.$route.params.subid && typeof (topSection.subsections) !== 'undefined') {
                        subSectionId = topSection.subsections.find(id => id === this.$route.params.subid);
                    } else {
                        subSectionId = true;
                    }
                }
            } else {
                subSectionId = true;
            }

            //пробуем получить данные, чтобы вызвать ошибку доступа, можно и без запроса, но так надёжнее
            //пока без запроса так
            let noSuccess = false;
            if (typeof this.topSections[0] !== 'undefined') {

                if (!subSectionId && this.$route.params.id && typeof this.topSections[0].all !== 'undefined') {
                    if (typeof this.topSections[0].all[this.$route.params.id] !== 'undefined') {
                        if (this.$route.params.subid) {
                            if (typeof this.topSections[0].all[this.$route.params.id].find(id => id === this.$route.params.subid) !== 'undefined') {
                                noSuccess = true;
                            }
                            if (this.sectionsLock.find(item => item.id === this.$route.params.subid)) {
                                noSuccess = false;
                            }
                        } else {
                            noSuccess = true;
                        }
                    } else {
                        noSuccess = false;
                    }
                }

            }

            if (!is404) {
                is404 = (this.$route.name === 'page404' || !subSectionId) && !noSuccess && !this.isLoadItems && !this.isLoadSections && !this.sectionsLock.find(item => item.id === this.$route.params.subid);
            }

            return is404;

        },
    },
    watch: {

    },
    methods: {
        isNotFoundRule() {
            let isRemovedRule = false;

            function getCookie(name) {
                let matches = document.cookie.match(new RegExp(
                    "(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"
                ));
                return matches ? decodeURIComponent(matches[1]) : undefined;
            }

            let ruleId = window.location.hash.replace('#', ''),
                ruleStatus = getCookie('ruleStatus_' + ruleId),
                isTestRemoved = window.localStorage.getItem('isTestNotFoundRemoved');
            if (ruleStatus === 'error' || isTestRemoved === 'true') {
                isRemovedRule = true;
            }

            return isRemovedRule;
        },
    },
    mounted() {
        this.$store.commit('popups/close', {name: this.popups.ruleDetail.name});
        this.$store.dispatch('rules/getItems', {
            screencast: true,
            reload: true
        });
    },
}
</script>
<style>

</style>
